export var FilmFilterKey;
(function (FilmFilterKey) {
    FilmFilterKey["Genre"] = "genre";
    FilmFilterKey["Attribute"] = "attribute";
    FilmFilterKey["Category"] = "category";
    FilmFilterKey["Event"] = "event";
})(FilmFilterKey || (FilmFilterKey = {}));
export var ShowtimeFilterKey;
(function (ShowtimeFilterKey) {
    ShowtimeFilterKey["Genre"] = "genre";
    ShowtimeFilterKey["Attribute"] = "attribute";
    ShowtimeFilterKey["Event"] = "event";
})(ShowtimeFilterKey || (ShowtimeFilterKey = {}));
export var SubscriptionFilterKey;
(function (SubscriptionFilterKey) {
    SubscriptionFilterKey["BillingPeriod"] = "billingPeriod";
    SubscriptionFilterKey["BillingRecurrence"] = "billingRecurrence";
    SubscriptionFilterKey["Subscription"] = "subscription";
})(SubscriptionFilterKey || (SubscriptionFilterKey = {}));
//# sourceMappingURL=filter-key.js.map